(function($) {
    $(() => {


        if($("#getting-started").length) {
            $("#getting-started").countdown(Date.parse($('.js-end-date').data("end").replace(/\./g, '/')), function(event) {
                $(this).text( event.strftime('%D nap %H óra %M perc') );
                if(event.elapsed) {
                    $('.js-status').addClass('closed').text("Lezárult");
                    $('.js-closed-remove').remove();
                }
            }).on('finish.countdown', function() {
                $('.js-status').addClass('closed').text("Lezárult");
                $('.js-closed-remove').remove();
            });    
        }

        /* FILTER COMPETITIONS */

        /* Trigger on click to filter */
        $('.js-filter-competitions-input').on('input', function(e) {
            e.preventDefault();
            $('.js-active-filter').trigger('click');
        });

        $('.js-competitions-filter').on('click', function(e) {
            e.preventDefault();
            $('.js-no-results-competitions').removeClass('show');

            /* Get the filter slug */
            const slug = $(this).data('slug');
         
            /* Add active and remove inactiv calsses */
            $('.js-competitions-filter').addClass('inactive').removeClass('js-active-filter');
            $(this).removeClass('inactive').addClass('js-active-filter');

            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'filter_competitions',
                    slug: slug,
                    text: $('.js-filter-competitions-input').val(),
                    status: $('.js-active-filter-status').data('slug'),
                },
                success(data) {
                    $('.js-filter-competitions-wrapper').html(data.html);
                    if (parseInt(data.page) <= 4) {
                        $('.js-get-more-competitions').hide();
                    } else {
                        $('.js-get-more-competitions').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                    if(data.page == 0) {
                        $('.js-get-more-competitions').hide();
                        $('.js-no-results-competitions').addClass('show');
                    }
                }
            }).done(response => {
                
            });
        });

        $('.js-competitions-filter-status').on('click', function(e) {
            e.preventDefault();

            /* Add active and remove inactiv calsses */
            $('.js-competitions-filter-status').addClass('inactive').removeClass('js-active-filter-status');
            $(this).removeClass('inactive').addClass('js-active-filter-status');

            $('.js-active-filter').trigger('click');
        });

          /* Get more competitions */
        $('.js-get-more-competitions').on('click', function(e) {
            e.preventDefault();

            /* Get the listed items for post_not__in */
            let post_ids = [];

            $('.card-news--competitions').each(function( index ) {
                post_ids.push($(this).data('id'));
            });

            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'get_more_competitions',
                    slug: $('.js-active-filter').data('slug'),
                    text: $('.js-filter-competitions-input').val(),
                    status: $('.js-active-filter-status').data('slug'),
                    post_ids
                },
                success(data) {
                    $('.js-filter-competitions-wrapper').append(data.html);
                    if (parseInt(data.page) <= 4) {
                        $('.js-get-more-competitions').hide();
                    } else {
                        $('.js-get-more-competitions').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                }
            }).done(response => {
               
            });
        });

        /* Get more news */
        $('.js-get-more-news-competitions').on('click', function(e) {
            e.preventDefault();

            /* Get the listed items for post_not__in */
            let post_ids = [];
    
            $('.card-news').each(function( index ) {
                post_ids.push($(this).data('id'));
            });
            
            /* Pass the filter slug and search input value to the BE */
            $.ajax({
                url: ajax.ajaxurl,
                dataType: 'JSON',
                type: 'POST',
                data: {
                    action: 'get_more_news_competitions',
                    categories: JSON.parse($('.js-categories').val()),
                    post_ids
                },
                success(data) {
                    $('.js-filter-news-wrapper-competitions').append(data.html);
                    if (parseInt(data.page) <= 4) {
                        $('.js-get-more-news-competitions').hide();
                    } else {
                        $('.js-get-more-news-competitions').show();
                    }
                    $(document).ready(function () {
                        $('.match-h').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });    
                    });
                }
            }).done(response => {
               
            });
        });

    });
})(jQuery);
